var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelSecondaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2293",
    "data-name": "Group 2293",
    transform: "translate(-16 -88)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    width: 24,
    height: 24,
    transform: "translate(16 88)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "x_4_",
    "data-name": "x (4)",
    transform: "translate(16 88)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    x1: 12,
    y2: 12,
    transform: "translate(6 6)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x2: 12,
    y2: 12,
    transform: "translate(6 6)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSecondaryIcon);
export default __webpack_public_path__ + "static/media/cancel-secondary-icon.d7767ba70b3df210be5a8c11d7c501b2.svg";
export { ForwardRef as ReactComponent };